/* eslint-disable max-len */
import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import { Translate } from 'react-redux-i18n';

import CategoryFeaturedComponent from '../form/CategoryFeatured';
import InvoicesComponent from '../invoices';
import OrdersComponent from '../orders';
import PurchasesFeedbackComponent from '../purchasesFeedback';
import PurchasesFeedbackRatingsComponent from '../purchasesFeedback/ratings';
import FormulaComponent from '../formula';

class ModalComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      title, body, visible, size, titleOkButtoon, id,
      showButtons, showOk = true, showCancel, items,
      bodyModal, type = 'orders', bodyFuncComponent,
      titleCancelButton = 'cancel',
    } = this.props;

    return (
      <section>
        <Modal
          visible={visible}
          width={size.width}
          height={['auto', 'unset'].includes(size.height) ? undefined : size.height}
          effect="fadeInDown"
          onClickAway={this.props.closeModal}
        >
          { id === 'orders' && type === 'orders'
          && <OrdersComponent items={items} closeModal={this.props.closeModal} />}

          { id === 'orders' && type === 'invoices'
          && <InvoicesComponent items={items} closeModal={this.props.closeModal} />}

          {type === 'category' && <CategoryFeaturedComponent />}

          {type === 'orderCategory' && (bodyFuncComponent())}

          {id === 'integrationError' && type === 'integrationError' && body }

          {id === 'purchasesFeedback' && type === 'feedback'
            && <PurchasesFeedbackComponent items={items} closeModal={this.props.closeModal} />}

          {id === 'purchasesFeedback' && type === 'ratings'
            && <PurchasesFeedbackRatingsComponent items={items} closeModal={this.props.closeModal} />}

          {id === 'formula' && type === 'formula'
            && (
            <FormulaComponent
              formula={this.props.formula}
              setFormula={this.props.setFormula}
              productId={this.props.productId}
              closeModal={this.props.closeModal}
            />
            )}

          {!id && (
            <div className="text-align-modal">
              <h1>{title}</h1>
              <p>{body}</p>
              {bodyModal && (<p>{bodyModal}</p>)}
            </div>
          )}

          {showButtons && (
            <div className="text-align-modal my-3">
              {showCancel && (
                <button
                  type="button"
                  className="btn btn-warning"
                  onClick={this.props.closeModal}
                >
                  <Translate value={titleCancelButton} />
                </button>
              )}

              {showOk && (
                <button
                  type="button"
                  className="btn btn-dark margin-left-btn-modal"
                  onClick={this.props.confirmModal}
                >
                  {titleOkButtoon}
                </button>
              )}
            </div>
          )}
        </Modal>
      </section>
    );
  }
}

export default ModalComponent;
